import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../client';
import { useAuthStore } from '../../store/authStore';

export interface MidiaEscola {
  id: string;
  titulo: string;
  descricao?: string;
  categoria: string;
  arquivoUrl: string;
  tipoArquivo: string;
  criadoEm: string;
}

export function useEscolaMidias() {
  const qc = useQueryClient();
  const escolaId = useAuthStore((s) => s.escolaId);
  const basePath = `/escolas/${escolaId}/midias`;

  const query = useQuery({
    queryKey: ['escola-midias', escolaId],
    queryFn: () => api.get(basePath).then((r) => r.data as MidiaEscola[]),
    enabled: !!escolaId,
  });

  const create = useMutation({
    mutationFn: (data: Record<string, unknown>) =>
      api.post(basePath, data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['escola-midias'] }),
  });

  const remove = useMutation({
    mutationFn: (id: string) =>
      api.delete(`${basePath}/${id}`).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['escola-midias'] }),
  });

  return {
    midias: query.data || [],
    isLoading: query.isLoading,
    create,
    remove,
  };
}
